// extracted by mini-css-extract-plugin
export default {"nav":"TabNav_nav__bo37U"};